const weixinMsgCode = {
    "40001": "读取请求体错误",
    "40002": "序列化错误",
    "40003": "反序列化错误",
    "40004": "数据不存在",
    "40007": "认证无效",
    "40008": "用户名或密码错误",
    "40009": "不存在这个实体",
    "40010": "请求体无效",
    "40011": "禁止访问",
    "40012": "用户名已存在",
    "40115": "密码错误",
    "40116": "内容太大",
    "40117": "缺少参数",
    "40118": "旧密码错误",
    "40119": "租户不存在",
    "40120": "验证码错误",
    "40121": "验证码失效",
    "40122": "错误的电话号码",
    "40123": "发送到通知中心失败",
    "40124": "错误的旧电话号码",
    "40150": "请求头错误",
    "50001": "产生用户ID错误",
    "50002": "数据库错误",
    "50003": "存储对象失败",
    "50004": "读取对象失败",
    "50005": "删除对象失败",
    "50099": "未知错误",
    "500001": '服务器错误',
    "500002": "请求超时",
    "600001": "[获取accessToken]接口调用出错",
    "600002": "[获取openid]接口调用出错",
    "600003": "数据库查询出错",
    "600004": "数据库更新出错",
    "600005": "只能更新支付失败或支付取消的流水记录",
    "600006": "订单号已存在",
    "600007": "数据库新增记录出错",
    "600008": "access_token校验过程发生错误",
    "600009": "用户详情获取失败",
    "600010": "access_token刷新失败",
    "600011": "本地文件读取access_token失败",
    "600012": "本地文件写入access_token失败",
    "600013": "本地自定义菜单配置读取失败",
    "600014": "[创建自定义菜单]接口调用出错",
    "600015": "业务系统返回MQ消息内容解析失败",
    "600016": "获取租户id失败",
    "600017": "发送微信消息失败",
    "600018": "项目不存在",
    "600019": "订单信息获取失败",
    "600020": "支付状态同步至业务系统失败",
    "600021": "对账单获取出错或当日无任何充值记录",
    "600022": "商户号或特约商户号无法获取",
    "600023": "对账汇总记录保存失败",
    "600024": "对账明细记录保存失败",
    "600025": "当前正处于夜间维护时间段，禁止执行此操作",
    "600026": "下单失败",
    "40125": "电话号码已被使用",
};

const npmsMsgCode = {
    "30101001": "租户姓名已存在",
    "30101002": "手机号已存在",
    "30101010": "项目不存在",
    "30101011": "租户在公众号端不存在",
    "30102001": "解除建筑租户关系异常",
    "30102002": "当前租户还未退租",
    "30113001": "设备断电异常",
    "30113002": "表计刷新底数异常",
    "30113003": "表计清零异常",
    "30113004": "设备通电异常",
    "30113005": "设备离线，无法下发充值",
    "30113006": "下发到表计失败",
    "30113007": "充值到设备，AIMP响应异常",
    "30113008": "下发充值设备，部分失败，请查看充值记录",
    "30113009": "不存在该充值记录",
    "30121001": "充值记录已经被标记",
    "30121002": "账单已录入",
    "30123001": "标记记录不存在",
    "30123002": "物业账单不存在",
    "30124001": "当前账单已是最新一期",
    "30124002": "当前账单已是第一期",
    "30131001": "计费方案名称已存在",
    "30131003": "计费方案执行计划名称已存在",
    "30133001": "默认计费方案，不可操作",
    "30133002": "计费方案被使用过，不可操作",
    "30133003": "计费方案有即将下发的计划，不可操作",
    "30133004": "计费方案不存在",
    "30133005": "计费方案下发记录不存在",
    "30133006": "计费方案下发失败",
    "30141001": "计费方案不存在",
    "30141002": "房间不存在",
    "30143001": "已执行过的计费执行计划，不可修改",
    "30151001": "新建楼宇或楼层或房间类型，父节点不能为空",
    "30151002": "请选择比当前节点低层级的节点",
    "30151003": "建筑节点不能为空",
    "30151004": "建筑节点已存在",
    "30151005": "新增总分表计关系表异常",
    "30152001": "删除建筑-删除总分表计异常",
    "30152002": "删除建筑-删除建筑表计关系异常",
    "30152003": "删除建筑节点异常",
    "30152004": "删除建筑表计关系异常",
    "30152005": "删除总分表计关系表异常",
    "30152006": "总表下存在分表不能解绑",
    "30153001": "房间/商铺存在租户，禁止操作",
    "30153002": "待绑定表计不能为空",
    "30153003": "建筑节点为房间/商铺，只能绑定一个表计",
    "30153004": "添加表计-绑定新表计异常",
    "30153005": "添加表计-解绑原表计异常",
    "30153006": "添加建筑表计关系异常",
    "30153007": "存在待下发至表计的充值",
    "30153008": "分表不能重复绑定",
    "30153009": "设备名已存在",
    "30154001": "建筑节点不存在",
    "30154002": "建筑节点查询异常",
    "30154003": "父节点不存在",
    "30154004": "查询建筑表计关系异常",
    "30154005": "查询设备异常",
    "30154006": "查询总分表计关系异常",
    "30154007": "更新总分表计关系异常",
    "30161001": "租户账期不存在",
    "30163001": "节假日下发失败",
    "30163002": "节假日下发记录不存在",
    "30163003": "节假日不存在",
    "30163004": "抄表时间下发失败",
    "30163005": "抄表时间下发记录不存在",
    "30163006": "抄表时间不存在",
    "30163007": "下发表计任务失败",
    "30163008": "供电局账期不存在",
    "30163009": "参数配置下发成功，更新记录失败",
    "30163010": "从表计获取参数失败",
    "30181001": "状态码前后不一致",
    "30181002": "请求授权令牌异常",
    "30181003": "请求用户信息异常",
    "30181004": "系统用户ID不能为空",
    "30181005": "旧密码不能为空",
    "30181006": "新密码不能为空",
    "30181007": "新密码和确认密码不相符",
    "30181008": "修改密码失败",
    "30181009": "系统用户名已存在",
    "30181010": "系统角色不存在",
    "30181011": "系统用户不存在",
    "30181012": "登出异常",
    "30203001": "待办事项不存在",
    "30263001": "修改通信管理机异常",
    "30263002": "修改表计异常",
    "30266001": "分页错误",
    "30266002": "URL参数缺失",
    "30266003": "角色ID不能为空",
    "30266004": "app_id不能为空",
    "30266005": "用户中心创建功能权限接口调用失败",
    "30266006": "新增资源权限失败",
    "30266007": "更新功能权限失败",
    "30266008": "创建数据权限失败",
    "30266009": "创建数据权限明细记录失败",
    "30266010": "更新数据权限记录失败",
    "30266011": '关联删除数据权限明细记录失败',
    "30266012": "删除功能权限失败",
    "30266013": "删除数据权限失败",
    "30266014": "用户中心角色详情接口返回数据异常",
    "30266015": "查询权限记录失败",
    "30266016": "查询数据权限明细记录失败",
    "30266017": "解析用户中心返回数据失败",
    "30266018": "查询数据权限建筑列表失败",
    "30266019": "权限名称重复",
    "30143003": "已执行过的计费执行计划，不可修改",
    "500001": '服务器错误',
    "60002": '设备断电异常',
    "60008": '设备通电异常',
    "20001": "读取请求体错误",
    "20002": "JSON序列化错误",
    "20003": "JSON反序列化错误",
    "20005": "访问数据库错误",
    "20006": "产生UUID出错",
    "20007": "访问令牌无效",
    "20008": "不存在这个实体",
    "20009": "无效的请求体",
    "20010": "禁止访问",
    "30001": "新建数据出错",
    "30002": "删除数据错误",
    "30003": "修改数据出错",
    "30004": "获取数据错误",
    "50000": "未知错误",
    "500002": "请求超时",
    "10000": " 无错误",
    "30125001": "开始时间超过三年",
    "30125002": "时间跨度超过一年",
    "30181013": "联系方式已存在",
    "30126001": "同时访问人数过多，请稍后再试",
};

export default { ...npmsMsgCode, ...weixinMsgCode};
